import { BiBellPlus, BiHistory, BiPauseCircle, BiShieldPlus, BiUserPlus } from 'react-icons/bi';
import { AiOutlineUsergroupDelete } from 'react-icons/ai';
const ViewAdminControls = ({ setModalAction }) => {
    const menuList = [
        { title: 'Send Memo', icon: <BiBellPlus />, action: "send-memo" },
        { title: 'Add Member', icon: <BiUserPlus />, action: "add-member" },
        { title: 'Delete Member', icon: <AiOutlineUsergroupDelete />, action: "delete-member" },
        { title: 'Make Admin', icon: <BiShieldPlus />, action: "make-admin" },
        { title: 'Renew Subscription', icon: <BiHistory />, action: "renew-subscription" },
        { title: 'Suspend Member', icon: <BiPauseCircle />, action: "suspend-member" },
    ]
    return <div className='admin-controls-parent bg-white'>
        <ul className='admin-controls  '>
            {menuList.map((item) => {
                return <li onClick={() => setModalAction(item.action)}>
                    <div className='control-icon'>{item.icon}</div>
                    <div className='control-title'>{item.title}</div>
                </li>
            })}
        </ul>
        <div className='large-bottom-control-button' onClick={() => { setModalAction("add-event") }}>
            <div className='but but-fill'>ADD EVENT</div>
        </div>
    </div>
}

export default ViewAdminControls;